/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inventory_Nav_Samples_DescriptionInputs */

const en_inventory_nav_samples_description = /** @type {(inputs: Inventory_Nav_Samples_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage customer sample requests`)
};

const es_inventory_nav_samples_description = /** @type {(inputs: Inventory_Nav_Samples_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrar solicitudes de muestras`)
};

/**
* | output |
* | --- |
* | "Manage customer sample requests" |
*
* @param {Inventory_Nav_Samples_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const inventory_nav_samples_description = /** @type {((inputs?: Inventory_Nav_Samples_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inventory_Nav_Samples_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inventory_nav_samples_description(inputs)
	return es_inventory_nav_samples_description(inputs)
});